<template>
  <div class="wtv-loading">
    <div class="wtv-progress" :style="{ width: state.progress + '%' }"></div>
    <div class="wtv-progress-back"></div>
    <div class="wtv-loading-text wtv-icon">{{ loadingText() }}</div>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed, reactive } from 'vue';
import { useStore } from 'vuex';
import { i18n } from '@/functions';

export default defineComponent({
  props: {
    code: String,
  },
  setup(props) {
    const $store = useStore();
    const loading = computed(() => $store.state.loading);
    const state = reactive({
      progressInterval: 0,
      progress: 0,
    });
    const showProgress = () => {
      let step = 0.5;
      let currentProgress = 0;
      return setInterval(() => {
        currentProgress += step;
        state.progress = Math.round(
          (Math.atan(currentProgress) / (Math.PI / 2)) * 100 * 1000,
        ) / 1000;
        if (state.progress >= 100) {
          if (state.progressInterval) clearInterval(state.progressInterval);
          state.progress = 0;
        } else if (state.progress >= 70) step = 0.1;
      }, 500);
    };
    state.progressInterval = showProgress();
    const loadingText = () => (!props.code
      ? loading.value.map((text: string) => i18n.loading[text]).join(', ')
      : i18n.loading[props.code]);

    return {
      state,
      loading,
      loadingText,
    };
  },
});
</script>

<style scoped>
.wtv-loading {
  padding: 24px;
  position: relative;
  background-color: var(--color-bg);
}
.wtv-progress {
  position: absolute;
  top: 0;
  left: 0;
  height: 8px;
  background-color: var(--color-main);
  transition: 2s;
}
.wtv-progress-back {
  position: absolute;
  top: 0;
  left: 0;
  height: 8px;
  background-color: var(--color-alt-5);
  width: 100%;
}
.wtv-loading-text {
  justify-content: center;
  display: flex;
}
.wtv-loading-text:before {
  content: '\f82b';
  font-size: 24px;
  width: 24px;
  height: 24px;
  color: var(--color-main);
  display: inline-flex;
  margin-right: 10px;
  animation: spin 2s infinite;
}
@keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(359deg);
    transform: rotate(359deg);
  }
}
</style>
